import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Subscription, tap } from 'rxjs';
import { inject } from '@angular/core';

import { DeactivationGuardedComponent } from '.';

@UntilDestroy()
export abstract class BaseDialogComponent extends DeactivationGuardedComponent {
  protected _dialog = inject(MatDialog);

  private onCancelSub: Subscription;
  constructor(protected dialogRef?: MatDialogRef<any>) {
    super();

    if (typeof this.onCancel === 'function' && this.dialogRef) {
      this.setDialogListener(this.dialogRef);
    }
  }

  onCancel?(): void;

  protected setDialogListener(ref: MatDialogRef<any>): void {
    //remove previous listener
    this.onCancelSub?.unsubscribe();

    this.onCancelSub = ref
      .backdropClick()
      .pipe(
        untilDestroyed(this),
        tap(() => {
          this.onCancel();
        })
      )
      .subscribe();
  }
}
